import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import {
  IVariableFinancieraRequest,
  IVariableFinancieraResponse,
  IVariableFinancieraSaveRequest,
  IVariableFinancieraSaveResponse
} from '../interfaces/variable-financiera.interface';

@Injectable({
  providedIn: 'root'
})
export class VariableFinancieraService {
  private readonly API_URL = `${environment.apiNewBackBaseUrl}VarFinancieras/sospa_rel_finList`;
  // Endpoints para guardar, editar y eliminar se agregarán según los flujos reales

  constructor(private http: HttpClient) { }

  getVariablesFinancieras(request: IVariableFinancieraRequest): Observable<IVariableFinancieraResponse> {
    return this.http.post<IVariableFinancieraResponse>(this.API_URL, request);
  }

  getOpcionesTipoRelacion(): Observable<any> {
    const url = `${environment.apiNewBackBaseUrl}OpcionesSolicitud/GetOpcionesVariables`;
    const payload = {
      sTabla: 'rel_fin',
      sCampo: 'Tipo',
      iIdioma: 0
    };
    return this.http.post<any>(url, payload);
  }

  saveVariableFinanciera(payload: IVariableFinancieraSaveRequest): Observable<IVariableFinancieraSaveResponse> {
    const url = `${environment.apiNewBackBaseUrl}VarFinancieras/sospa_rel_finAdd`;
    return this.http.post<IVariableFinancieraSaveResponse>(url, payload);
  }

  getVariableFinancieraForEdit(numero_relacion: string): Observable<IVariableFinancieraResponse> {
    const url = `${environment.apiNewBackBaseUrl}VarFinancieras/sospa_rel_finListDet`;
    const payload = {
      que: 5,
      tope: '',
      cmd: '',
      numero_relacion: numero_relacion,
      tipo: '',
      descripcion: '',
      formula: '',
      periodicidad: '',
      tipoVariable: ''
    };
    return this.http.post<IVariableFinancieraResponse>(url, payload);
  }

  updateVariableFinanciera(payload: IVariableFinancieraSaveRequest): Observable<IVariableFinancieraSaveResponse> {
    const url = `${environment.apiNewBackBaseUrl}VarFinancieras/sospa_rel_finUpd`;
    return this.http.post<IVariableFinancieraSaveResponse>(url, payload);
  }

  deleteVariableFinanciera(numero_relacion: string): Observable<IVariableFinancieraSaveResponse> {
    const url = `${environment.apiNewBackBaseUrl}VarFinancieras/sospa_rel_finDelete`;
    const payload = {
      que: 3,
      tope: '',
      cmd: '',
      numero_relacion: numero_relacion,
      tipo: '',
      descripcion: '',
      formula: '',
      periodicidad: '',
      tipoVariable: ''
    };
    return this.http.post<IVariableFinancieraSaveResponse>(url, payload);
  }
} 